import { FC } from "react";
import styles from "./ManagementCalmness.module.scss";
import { useTranslation } from "next-i18next";
import { H2 } from "../../../../components/Typography";
import { ManagementPointCard } from "../../../../components/Cards/ManagementPointCard";
import { SvgArea } from "../../../../icons/complex-info";
import { SvgPhoto } from "../../../../icons/management/SvgPhoto";
import { SvgExchange } from "../../../../icons/management/SvgExchange";
import { SvgGraph } from "../../../../icons/management/SvgGraph";
import { SvgHammer } from "../../../../icons/management/SvgHammer";

const CARDS = [
  {
    text: "card1",
    icon: <SvgPhoto className={styles.calm__icon} />,
  },
  {
    text: "card2",
    icon: <SvgExchange className={styles.calm__icon} />,
  },
  {
    text: "card3",
    icon: <SvgGraph className={styles.calm__icon} />,
  },
  {
    text: "card4",
    icon: <SvgHammer className={styles.calm__icon} />,
  },
];

interface IManagementCalmness {}
export const ManagementCalmness: FC<IManagementCalmness> = () => {
  const { t } = useTranslation("index", { keyPrefix: "managementPage.calm" });
  return (
    <div className={styles.calm}>
      <div className={styles.container}>
        <H2 className={styles.calm__title}>{t("title")}</H2>
        <div className={styles.calm__cards}>
          {CARDS.map((c) => (
            <ManagementPointCard key={c.text} icon={c.icon} text={t(c.text)} />
          ))}
        </div>
      </div>
    </div>
  );
};
